import { render, staticRenderFns } from "./AppTextButton.vue?vue&type=template&id=012f60bf&scoped=true"
import script from "./AppTextButton.vue?vue&type=script&lang=js"
export * from "./AppTextButton.vue?vue&type=script&lang=js"
import style0 from "./AppTextButton.vue?vue&type=style&index=0&id=012f60bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012f60bf",
  null
  
)

export default component.exports